import { gql } from "apollo-angular";

export const GET_ORDER_EVENTS = gql`
  query orderEvents($id: String!) {
    orderEvents(id: $id) {
      payload
      timestamp
      type
    }
  }
`;

export const GET_ORDER = gql`
  query getOrder($id: String!) {
    order(id: $id) {
      id
      sender {
        publisher
        contact
        email
      }
      status {
        status
      }
      receiver {
        contact
        email
      }
      order {
        idtitle
        ordernumberdiso
        orderdate
        filedeliverydate
        customernumber
        titleinfo {
          category
          title
          isbn
          author
          pages
        }
        totalprintrun
        binding {
          bindingtype
          adhesivetype
          spinetype
        }
        edition {
          number
        }
        delivery {
          datelatest
        }
        automaticorder
        textpartprint {
          blocklength
          blockwidth
        }
      }
      publisher {
        standardStudios {
          createdDate
          lastModifiedDate
          id
          displayName
        }
      }
      studios {
        id
        displayName
      }
    }
  }
`;

export const UPDATE_ORDERS_STUDIO_ASSIGNMENTS = gql`
  mutation updateOrderStudiosAssignments(
    $ordersIds: [UUID!]
    $studiosToAddIds: [UUID!]
    $studiosToRemoveIds: [UUID!]
  ) {
    updateOrderStudiosAssignments(
      ordersIds: $ordersIds
      studiosToAddIds: $studiosToAddIds
      studiosToRemoveIds: $studiosToRemoveIds
    ) {
      id
      publisher {
        standardStudios {
          id
          displayName
        }
      }
      studios {
        id
        displayName
      }
    }
  }
`;
